// frontend/src/utils/constants.js

export const GRENADA_PARISHES = [
  'Saint George',
  'Saint David',
  'Saint Andrew',
  'Saint Patrick',
  'Saint Mark',
  'Saint John',
  'Carriacou and Petite Martinique',
];